import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  listSupplier (URL, header, success, error) {
    Vue.axios.get(URL + 'cycle', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getOrderProcess (URL, header, success, error) {
    Vue.axios.get(URL + 'cycle/orderprocess', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getDock (URL, id, header, success, error) {
    Vue.axios.get(URL + 'cycle/dock?spl_id=' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getSupplier (URL, id, header, success, error) {
    Vue.axios.get(URL + 'cycle/supplier?spl_id=' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  listPattern (URL, id, header, success, error) {
    Vue.axios.get(URL + 'cycle/pattern?spl_id=' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getCycleDetail (URL, header, success, error) {
    Vue.axios.get(URL + 'cycle/detail', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getCycleDetailid (URL, id, header, success, error) {
    Vue.axios.get(URL + 'cycle/detailid?cdc_id=' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addCycle (URL, obj, header, success, error) {
    Vue.axios.post(URL + 'cycle', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editCycle (URL, id, obj, header, success, error) {
    Vue.axios.put(URL + 'cycle/' + id, obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  orderStatus (URL, id, obj, header, success, error) {
    Vue.axios.put(URL + 'cycle/orderstatus/' + id, obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  orderActive (URL, id, obj, header, success, error) {
    Vue.axios.put(URL + 'cycle/orderactive/' + id, obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteCycle (URL, id, header, success, error) {
    Vue.axios.delete(URL + 'cycle/' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addCycleList (URL, obj, header, success, error) {
    Vue.axios.post(URL + 'cyclelist', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editCycleList (URL, id, obj, header, success, error) {
    Vue.axios.put(URL + 'cyclelist/' + id, obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteCycleList (URL, id, header, success, error) {
    Vue.axios.delete(URL + 'cyclelist/' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/cycle.js